const TIME_ZONE = 'UTC';

export default TIME_ZONE;
